import React from 'react';
import { PersonEditTemplate } from 'themes/application/person/pages';
import { observer } from 'mobx-react';
import { PersonEditViewStore } from 'application/person/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new PersonEditViewStore(rootStore), 'editView')
@observer
class PersonEdit extends React.Component {
    render() {
        return <PersonEditTemplate {...this.props} />
    }
}

export default PersonEdit;
